import { render, staticRenderFns } from "./PrivilegeExtraPayload.vue?vue&type=template&id=20ba74d8&scoped=true&"
import script from "./PrivilegeExtraPayload.vue?vue&type=script&lang=js&"
export * from "./PrivilegeExtraPayload.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeExtraPayload.vue?vue&type=style&index=0&id=20ba74d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba74d8",
  null
  
)

export default component.exports